<form (ngSubmit)="onSubmit()" #filtroForm="ngForm">
    <label class="center-block">
        Veículo
    </label>
    <div class="input-group">
        <input [(ngModel)]="filtro.parametro" type="text" name="veiculo" class="form-control input"
            style="min-width: 200px;" matTooltip="Preecha para a pesquisa de veículo"
            (ngModelChange)="search$.next($event)" [matAutocomplete]="auto" placeholder="digite aqui" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)='getPosts($event.option.value)'
            [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option" >
                {{option.busca}}
            </mat-option>
        </mat-autocomplete>
        <button type="submit" mat-icon-button style="margin-left: 10px" matTooltip="Pesquise o veículo">
            <mat-icon aria-hidden="false" aria-label="Pesquise o veículo" fontIcon="search">
            </mat-icon>
        </button>
        <button type="button" mat-icon-button style="margin-left: 10px"
            matTooltip="Limpe o resultado da pesquisa de veículo" (click)="limpaFiltro()">
            <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de veículo" fontIcon="delete">
            </mat-icon>
        </button>
    </div>
</form>
<div *ngIf="filtro.veiculo" class="supercombo-selecionado panel panel-info">
    <div class="panel-body">
        <div class="row">
            <div class="col-md-2">
                <label>
                    Placa
                </label>
            </div>
            <div class="col-md-3">
                <label>
                    Nº de Frota
                </label>
            </div>
            <div class="col-md-3">
                <label>
                    Modelo
                </label>
            </div>
            <div class="col-md-3">
                <label>
                    Cód. Veículo
                </label>
            </div>
        </div>
        <div class="row dados">
            <div class="col-md-2 ">
                <span class="mat-cell">{{ filtro.veiculo.placa }}</span>
            </div>
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.veiculo.numeroFrota }}</span>
            </div>
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.veiculo.modelo }}</span>
            </div>
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.veiculo.codigo }}</span>
            </div>
        </div>
    </div>
</div>